import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from "../..";
import SectionItemContent from "./SectionItemContent";
import SectionItemTitle from "./SectionItemTitle";
import { getRest } from "../../utils";

/**
 * Une section de fiche.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionItem = function SectionItem(props) {
  var children = props.children,
    content = props.content,
    compact = props.compact,
    single = props.single,
    title = props.title,
    titleRenderer = props.titleRenderer;

  /** Inject c in SectionItemContent */
  var render = function render(c) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!compact && /*#__PURE__*/_jsx(Grid.Row, {}), /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          paddingBottom: 0
        },
        children: /*#__PURE__*/_jsx(SectionItemTitle, {
          title: title,
          renderer: titleRenderer
        })
      }), /*#__PURE__*/_jsx(SectionItemContent, {
        compact: compact,
        children: c
      })]
    });
  };
  render.handledProps = [];
  if (!single) {
    return render(content || children);
  }
  var rest = getRest(SectionItem, props);
  return /*#__PURE__*/_jsx(Grid, Object.assign({}, rest, {
    children: render(content || children)
  }));
};

/** Proptypes. */
SectionItem.handledProps = ["children", "compact", "content", "single", "title", "titleRenderer"];
SectionItem.propTypes = {
  /** */
  children: PropTypes.node,
  /** */
  content: PropTypes.node,
  /** A SectionItem may take up only as much space as is necessary. */
  compact: PropTypes.bool,
  /** A SectionItem may appears with other SectionItem */
  single: PropTypes.bool,
  /** Title. */
  title: PropTypes.string,
  /** Title renderer. */
  titleRenderer: PropTypes.func
};

/** Default props. */
SectionItem.defaultProps = {
  single: true
};
export default SectionItem;